import { IAssessmentSchemaInfo } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAssessmentQuestions, IAssessmentTopicWithType } from '../../services/assessments.service'
import { RootState } from '../store'

interface AssessmentsState {
  info: IAssessmentSchemaInfo[] | undefined
  topics: IAssessmentTopicWithType[]
  questions: IAssessmentQuestions
  activeTopicIds: string[]
}

const initialState: AssessmentsState = {
  info: undefined,
  topics: [],
  questions: {},
  activeTopicIds: [],
}

export const assessmentsSlice = createSlice({
  name: 'assessmentsReducer',
  initialState,
  reducers: {
    setAssessmentsInfo: (state, action: PayloadAction<IAssessmentSchemaInfo[]>) => {
      state.info = action.payload
    },
    setAllTopics: (state, action: PayloadAction<IAssessmentTopicWithType[]>) => {
      state.topics = action.payload
    },
    setAllQuestions: (state, action: PayloadAction<IAssessmentQuestions>) => {
      state.questions = action.payload
    },
    setActiveTopicIds: (state, action: PayloadAction<string[]>) => {
      state.activeTopicIds = action.payload
    },
  },
})

export const { setAssessmentsInfo, setAllTopics, setAllQuestions, setActiveTopicIds } = assessmentsSlice.actions
export default assessmentsSlice.reducer
export const selectAssessments = (state: RootState): AssessmentsState => state.assessmentsReducer
export const selectAssessmentsInfo = (state: RootState): IAssessmentSchemaInfo[] | undefined => state.assessmentsReducer.info
export const selectAllTopics = (state: RootState): IAssessmentTopicWithType[] => state.assessmentsReducer.topics
export const selectAllQuestions = (state: RootState): IAssessmentQuestions => state.assessmentsReducer.questions
export const selectActiveTopicIds = (state: RootState): string[] => state.assessmentsReducer.activeTopicIds
